import React from 'react'
import ViewIndustryComponent from '../components/ViewIndustryComponent'
import { connect } from 'react-redux'
function ViewIndustryContainer() {
  return (
    <div className="p-grid pageWrapper">
      <ViewIndustryComponent />
    </div>
  )
}
const mapStateToProps = state => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewIndustryContainer)
